//表单数据
export const formData = {
  userId:'',
  houseId: '',
  title: '',
  liveTime: '',
  remark: '',
  photo: '',
  visitsCount:null,
  introduce: '',
  adminInfo: '',
  playbackAddress: ''
}

//表单验证规则
export const formRules = {
  userId: [{ required: true, message: "主播不能为空", trigger: "blur" }],
  houseId: [{ required: true, message: "楼盘不能为空", trigger: "blur" }],
  title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
  photo: [{ required: true, message: "图片不能为空", trigger: "blur" }],
  visitsCount:[{required: true, message: "观看人数基数不能为空", trigger: "blur" }],
  introduce: [{ required: true, message: "正文不能为空", trigger: "blur" }],
  liveTime: [{ required: true, message: "直播时间不能为空", trigger: "blur" }],
  adminInfo: [{ required: true, message: "管理员不能为空", trigger: "blur" }]
}